export default {
  'menu.cms.site.website': '网站配置',
  'menu.cms.site.sitemap': 'Sitemap',
  'menu.cms.site.robots': 'Robots',
  'menu.cms.workbench': '工作台',
  'menu.cms.workbench.overview': '运营总览',
  'menu.cms.workbench.my-work': '我的工作',
  'menu.cms.workbench.calendar': '内容日历',
  'menu.cms.workbench.risk': '风险提醒',
  'menu.cms.operation': '运营规划',
  'menu.cms.operation.plan': '运营计划',
  'menu.cms.operation.topic': '选题库',
  'menu.cms.operation.task': '内容任务',
  'menu.cms.operation.review': '运营复盘',
  'menu.cms.content': '内容资产',
  'menu.cms.content.all': '全部内容',
  'menu.cms.content.review': '审核列表',
  'menu.cms.content.categories': '分类管理',
  'menu.cms.content.tags': '标签管理',
  'menu.cms.content.categories.master': '内容母本',
  'menu.cms.content.categories.product': '产品内容',
  'menu.cms.content.categories.solution': '解决方案',
  'menu.cms.content.categories.case': '客户案例',
  'menu.cms.content.categories.article': '文章与观点',
  'menu.cms.content.categories.faq': 'FAQ与术语',
  'menu.cms.content.categories.channel': '渠道版本',
  'menu.cms.content.categories.archive': '内容归档',
  'menu.cms.content.material': '素材中心',
  'menu.cms.ai': 'AI创作',
  'menu.cms.ai.create': '创作工作台',
  'menu.cms.ai.topic': 'AI选题',
  'menu.cms.ai.write': 'AI写作',
  'menu.cms.ai.channel': '渠道改编',
  'menu.cms.ai.review': '内容审核',
  'menu.cms.ai.records': '创作记录',
  'menu.cms.site': '站点运营',
  'menu.cms.site.list': '站点列表',
  'menu.cms.site.categories': '分类列表',
  'menu.cms.site.analytics': '站长统计',
  'menu.cms.site.overview': '站点概览',
  'menu.cms.site.brief': '站点建设简报',
  'menu.cms.site.page': '页面内容',
  'menu.cms.site.mapping': '内容映射',
  'menu.cms.site.publish': '内容发布',
  'menu.cms.site.publication': '发布记录',
  'menu.cms.site.domain': '域名档案',
  'menu.cms.site.sync': '同步记录',
  'menu.cms.channel': '渠道运营',
  'menu.cms.channel.account': '渠道账号',
  'menu.cms.channel.pending': '待发布内容',
  'menu.cms.channel.publish': '发布任务',
  'menu.cms.channel.record': '发布记录',
  'menu.cms.channel.template': '渠道模板',
  'menu.cms.seo': 'SEO/GEO',
  'menu.cms.seo.overview': 'GEO 总览',
  'menu.cms.seo.question': '问题库',
  'menu.cms.seo.diagnosis': '内容诊断与任务',
  'menu.cms.seo.keyword': '关键词库',
  'menu.cms.seo.site-diagnosis': '站点诊断',
  'menu.cms.seo.coverage': '内容覆盖',
  'menu.cms.seo.task': '优化任务',
  'menu.cms.lead': '线索转化',
  'menu.cms.lead.overview': '转化总览',
  'menu.cms.lead.form': '表单管理',
  'menu.cms.lead.record': '留资记录',
  'menu.cms.lead.visitor': '访客记录',
  'menu.cms.lead.source': '来源分析',
  'menu.cms.lead.crm': 'CRM同步',
  'menu.cms.analytics': '数据分析',
  'menu.cms.analytics.overview': '经营总览',
  'menu.cms.analytics.product': '产品分析',
  'menu.cms.analytics.site': '站点分析',
  'menu.cms.analytics.content': '内容分析',
  'menu.cms.analytics.channel': '渠道分析',
  'menu.cms.analytics.seo': 'SEO/GEO分析',
  'menu.cms.analytics.conversion': '转化分析',
  'menu.cms.product': '品牌与产品',
  'menu.cms.product.enterprise': '企业信息',
  'menu.cms.product.brand': '品牌管理',
  'menu.cms.product.product': '产品管理',
  'menu.cms.product.solution': '解决方案',
  'menu.cms.product.audience': '客户群体',
  'menu.cms.product.expert': '专家管理',
  'menu.cms.settings': '设置',
  'menu.cms.settings.general': '常规设置',
  'menu.cms.settings.theme': '主题选项',
  'menu.cms.settings.forms': '表单管理',
  'menu.cms.settings.submissions': '提交记录',
  'menu.cms.governance': '设置与治理',
  'menu.cms.governance.integration': 'API与Webhook',
  'menu.cms.governance.member': '成员与权限',
  'menu.cms.governance.review': '审核流程',
  'menu.cms.governance.content-type': '内容类型',
  'menu.cms.governance.brand-rule': '品牌规范',
  'menu.cms.governance.ai': 'AI设置',
  'menu.cms.governance.data-source': '数据源',
  'menu.cms.governance.notification': '通知设置',
  'menu.cms.governance.log': '操作日志',
  'menu.cms.content.edit': '内容编辑',
  'menu.cms.ai.channel-work': '渠道改编',
  'menu.cms.site.detail': '站点详情',
  'menu.cms.site.brief-detail': '站点简报',
  'menu.cms.site.page-detail': '页面内容',
  'menu.cms.site.mapping-detail': '内容映射',
  'menu.cms.seo.diagnosis-detail': '内容诊断',
  'menu.cms.product.detail': '产品详情',
  'menu.workbench': '工作台',
  'menu.more-blocks': '更多区块',
  'menu.home': '首页',
  'menu.admin': '管理页',
  'menu.admin.sub-page': '二级管理页',
  'menu.system': '系统管理',
  'menu.system.menu': '菜单管理',
  'menu.system.user': '用户管理',
  'menu.system.role': '角色管理',
  'menu.settings': '设置',
  'menu.login': '登录',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': '分析页',
  'menu.dashboard.monitor': '监控页',
  'menu.dashboard.workplace': '工作台',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': '表单页',
  'menu.form.basic-form': '基础表单',
  'menu.form.step-form': '分步表单',
  'menu.form.step-form.info': '分步表单（填写转账信息）',
  'menu.form.step-form.confirm': '分步表单（确认转账信息）',
  'menu.form.step-form.result': '分步表单（完成）',
  'menu.form.advanced-form': '高级表单',
  'menu.list': '列表页',
  'menu.list.table-list': '查询表格',
  'menu.list.basic-list': '标准列表',
  'menu.list.card-list': '卡片列表',
  'menu.list.search-list': '搜索列表',
  'menu.list.search-list.articles': '搜索列表（文章）',
  'menu.list.search-list.projects': '搜索列表（项目）',
  'menu.list.search-list.applications': '搜索列表（应用）',
  'menu.profile': '详情页',
  'menu.profile.basic': '基础详情页',
  'menu.profile.advanced': '高级详情页',
  'menu.result': '结果页',
  'menu.result.success': '成功页',
  'menu.result.fail': '失败页',
  'menu.exception': '异常页',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': '触发错误',
  'menu.account': '个人页',
  'menu.account.center': '个人中心',
  'menu.account.workbench': '回到工作台',
  'menu.account.tenantManagement': '企业管理',
  'menu.account.trigger': '触发报错',
  'menu.account.logout': '退出登录',
  'menu.editor': '图形编辑器',
  'menu.editor.flow': '流程编辑器',
  'menu.editor.mind': '脑图编辑器',
  'menu.editor.koni': '拓扑编辑器',
};
